import React, { useState, useEffect } from 'react';
import { Line, Bar, Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, BarElement, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, BarElement, ArcElement, Tooltip, Legend);

export default function ThinkyIOTDashboard({ onBack }) {
  // Dummy data for devices
  const [devices] = useState([
    { id: 1, name: 'Device A' },
    { id: 2, name: 'Device B' },
    { id: 3, name: 'Device C' },
  ]);

  const [telemetryData, setTelemetryData] = useState({});

  useEffect(() => {
    // Initialize dummy telemetry for devices
    const initialData = {};
    devices.forEach(d => {
      initialData[d.id] = Array.from({ length: 10 }, () => Math.floor(Math.random() * 100));
    });
    setTelemetryData(initialData);

    // Simulate real-time updates
    const interval = setInterval(() => {
      setTelemetryData(prev => {
        const newData = {};
        devices.forEach(d => {
          const arr = prev[d.id] ? [...prev[d.id].slice(1)] : [];
          arr.push(Math.floor(Math.random() * 100));
          newData[d.id] = arr;
        });
        return newData;
      });
    }, 2000);

    return () => clearInterval(interval);
  }, [devices]);

  return (
    <div className="min-h-screen bg-black text-white px-4 py-8">
      <button onClick={onBack} className="mb-4 px-4 py-2 bg-blue-600 rounded hover:bg-blue-500 w-24">&larr; Back</button>
      <h1 className="text-lg lg:text-xl font-bold mb-6">Dashboards & Visualization</h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {devices.map(device => (
          <div key={device.id} className="bg-neutral-900 border border-neutral-800 rounded-2xl p-5 shadow-sm">
            <h3 className="text-lg font-semibold mb-2">{device.name}</h3>

            <p className="text-sm mb-2">Telemetry Trend:</p>
            <div className="h-24 mb-4">
              <Line
                data={{
                  labels: Array.from({ length: 10 }, (_, i) => i + 1),
                  datasets: [{
                    data: telemetryData[device.id] || [],
                    borderColor: '#3b82f6',
                    backgroundColor: 'rgba(59, 130, 246, 0.2)',
                    tension: 0.3,
                    pointRadius: 0,
                  }]
                }}
                options={{
                  responsive: true,
                  plugins: { legend: { display: false } },
                  scales: { x: { display: false }, y: { display: true, ticks: { color: 'white' }, grid: { color: '#374151' } } }
                }}
              />
            </div>

            <p className="text-sm mb-2">Status Distribution:</p>
            <div className="h-24">
              <Doughnut
                data={{
                  labels: ['Online', 'Offline', 'Error'],
                  datasets: [{
                    data: [Math.floor(Math.random()*50)+50, Math.floor(Math.random()*20), Math.floor(Math.random()*10)],
                    backgroundColor: ['#16a34a', '#6b7280', '#dc2626'],
                  }]
                }}
                options={{
                  plugins: { legend: { labels: { color: 'white' } } }
                }}
              />
            </div>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8">
        <div className="bg-neutral-900 border border-neutral-800 rounded-2xl p-5 shadow-sm">
          <h3 className="text-lg font-semibold mb-2">System Overview (Bar Chart)</h3>
          <Bar
            data={{
              labels: ['Device A', 'Device B', 'Device C'],
              datasets: [{
                label: 'Avg Telemetry',
                data: devices.map(d => telemetryData[d.id] ? Math.floor(telemetryData[d.id].reduce((a,b)=>a+b,0)/telemetryData[d.id].length) : 0),
                backgroundColor: '#f97316'
              }]
            }}
            options={{
              responsive: true,
              plugins: { legend: { labels: { color: 'white' } } },
              scales: { x: { ticks: { color: 'white' }, grid: { color: '#374151' } }, y: { ticks: { color: 'white' }, grid: { color: '#374151' } } }
            }}
          />
        </div>

        <div className="bg-neutral-900 border border-neutral-800 rounded-2xl p-5 shadow-sm">
          <h3 className="text-lg font-semibold mb-2">Alert Summary</h3>
          <ul className="list-disc list-inside text-sm">
            <li>Device A: High Temperature Alert</li>
            <li>Device B: Low Battery Notification</li>
            <li>Device C: Offline Alarm</li>
          </ul>
        </div>
      </div>
    </div>
  );
}